import React from "react";
import { Box, Container, Stack, Typography } from "@mui/material";

import { graphql, useStaticQuery } from "gatsby";
import CommunicationMethod, {
  CommunicationMethodProps,
} from "./CommunicationMethod";
import { useExtendedTheme } from "@theme/Context";

const communicationMethodQuery = graphql`
  query communicationMethodsQuery {
    communicationMethods: allContentfulCommunicatoinMethod(
      sort: { priority: ASC }
    ) {
      nodes {
        name
        link
        priority
      }
    }
  }
`;

const Footer = () => {
  const communicationMethods: Array<CommunicationMethodProps> =
    useStaticQuery(communicationMethodQuery).communicationMethods.nodes || [];
  const { theme } = useExtendedTheme();
  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        marginTop: "auto",
        bgcolor:
          theme.palette.mode === "dark"
            ? theme.palette.grey[900]
            : "primary.light",
      }}
    >
      <Container sx={{ py: 5 }} maxWidth="xl">
        <Box sx={{ textAlign: "center" }}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            flexWrap="wrap"
          >
            {communicationMethods.map((communicationMethod) => (
              <CommunicationMethod
                key={`communication-method-${communicationMethod.name}`}
                {...communicationMethod}
              />
            ))}
          </Stack>
        </Box>
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <Typography variant="body2">
            Copyright © {new Date().getFullYear()} Safa Keskin, Built with
            {` `}
            <a href="https://www.gatsbyjs.com">Gatsby</a> and
            {` `}
            <a href="https://mui.com">Material UI</a>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
